import { render, staticRenderFns } from "./manage_logs.vue?vue&type=template&id=8f3945dc&scoped=true&"
import script from "./manage_logs.vue?vue&type=script&lang=ts&"
export * from "./manage_logs.vue?vue&type=script&lang=ts&"
import style0 from "./manage_logs.vue?vue&type=style&index=0&id=8f3945dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3945dc",
  null
  
)

export default component.exports